<template>
    <modal ref="modal" unclosable>
      <div id="sub-wrapper">
        <div class="title">{{ $t('modals.unblock_sound.title') }}</div>
        <img src="~@/assets/img/sound_blocked.svg"/>
        <div class="text">{{ $t('modals.unblock_sound.text') }}</div>
        <button @click="unblock">{{ $t('modals.unblock_sound.button') }}</button>
      </div>
    </modal>
</template>

<script>
export default {
  methods: {
    show () {
      this.$refs.modal.show()
    },
    hide () {
      this.$refs.modal.hide()
    },
    unblock () {
      // Play all
      document.querySelectorAll('video').forEach(item => item.play())

      // Hide modal
      this.hide()
    }
  }
}
</script>

<style scoped>

#sub-wrapper {
  width: 25em;
}

#sub-wrapper .title {
  margin-bottom: 0.5em;
}

#sub-wrapper img, #sub-wrapper .text {
  margin-bottom: 1em;
}

</style>
